/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Dont_Have_AccountInputs */

const en_login_dont_have_account = /** @type {(inputs: Login_Dont_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't have an account?`)
};

const fr_login_dont_have_account = /** @type {(inputs: Login_Dont_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous n'avez pas de compte ?`)
};

const de_login_dont_have_account = /** @type {(inputs: Login_Dont_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie haben noch kein Konto?`)
};

const it_login_dont_have_account = /** @type {(inputs: Login_Dont_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non hai un account?`)
};

const ru_login_dont_have_account = /** @type {(inputs: Login_Dont_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У вас нет аккаунта?`)
};

const es_login_dont_have_account = /** @type {(inputs: Login_Dont_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿No tienes una cuenta?`)
};

const zh_cn2_login_dont_have_account = /** @type {(inputs: Login_Dont_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`还没有账号？`)
};

const ja_login_dont_have_account = /** @type {(inputs: Login_Dont_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントをお持ちではありませんか？`)
};

const hi_login_dont_have_account = /** @type {(inputs: Login_Dont_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या आपके पास खाता नहीं है?`)
};

const pt_pt2_login_dont_have_account = /** @type {(inputs: Login_Dont_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não tem uma conta?`)
};

/**
* | output |
* | --- |
* | "Don't have an account?" |
*
* @param {Login_Dont_Have_AccountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_dont_have_account = /** @type {((inputs?: Login_Dont_Have_AccountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Dont_Have_AccountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_dont_have_account(inputs)
	if (locale === "de") return de_login_dont_have_account(inputs)
	if (locale === "it") return it_login_dont_have_account(inputs)
	if (locale === "ru") return ru_login_dont_have_account(inputs)
	if (locale === "es") return es_login_dont_have_account(inputs)
	if (locale === "zh-CN") return zh_cn2_login_dont_have_account(inputs)
	if (locale === "ja") return ja_login_dont_have_account(inputs)
	if (locale === "hi") return hi_login_dont_have_account(inputs)
	if (locale === "pt-PT") return pt_pt2_login_dont_have_account(inputs)
	return en_login_dont_have_account(inputs)
});